import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { StatusMessage, StatusMessageModel } from '../../Widgets/StatusMessage'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface AddBonusPagePageOptions extends PageOptionsBase {
    processUrl: string;
}

export class AddBonusPage extends PageBase<AddBonusPagePageOptions> {
    private importButton: HTMLInputElement;
    private fileInput: HTMLInputElement;
    private submitButton: HTMLElement;
    private closeDialogButton: HTMLElement;
    private configurationForm: HTMLFormElement;

    constructor(options: AddBonusPagePageOptions) {
        super(options);
        this.setConfiguration = this.setConfiguration.bind(this);
        this.submitButton = document.getElementById("btnSubmit");
        if (this.submitButton != null) {
            this.submitButton.onclick = () => this.calculateContribution();
        }
        this.closeDialogButton = document.getElementById("btnHideConfirmation");
        this.closeDialogButton.onclick = () => this.closeDialog();
        this.configurationForm = <HTMLFormElement>document.getElementById("frmBonusConfiguration");
    }

    init(): void {
        this.fileInput = (<HTMLInputElement>document.getElementById("fileInput"));
        this.fileInput.onchange = () => this.setImportFileButtonDisabledProp();
        this.importButton = <HTMLInputElement>document.getElementById("btnImportFile");
        this.importButton.onclick = () => this.setConfiguration();
        this.setImportFileButtonDisabledProp();
    }

    private setConfiguration() {
        var importButton = this.importButton;
        importButton.disabled = true;
        var bonusInput = Utils.getJQueryById("bonusName");
        var data = new FormData();
        data.append('file', this.fileInput.files[0]);
        data.append('name', bonusInput.val());
        $.ajax({
            url: this._options.processUrl,
            type: "POST",
            processData: false,
            contentType: false,
            data: data,
            success: function (data) {
                (<any>window).editor.set(data.configuration);
                Utils.getJQueryById("BonusConfigurationJson").val((<any>window).editor.getText());
            },
            complete: function (data: any) {
                var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
                var statusMessageData: StatusMessageModel = JSON.parse(data.responseJSON.statusMessages);
                var statusMessage = new StatusMessage(statusMessageData);
                statusMessageWrapper.html(statusMessage.getHTMLmessage());
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                importButton.disabled = false;
                if (jqXHR.status === 404) {
                    window.location.replace(window.location.href);
                }
            }
        });
    }

    private openDialog() {
        document.getElementById("configurationConfirmation").hidden = false;
    }
    private closeDialog() {
        document.getElementById("configurationConfirmation").hidden = true;
    }

    private calculateContribution() {
        const jsonString = Utils.getJQueryById("#BonusConfigurationJson").val();
        const json = JSON.parse(jsonString);
        let totalContribution = 0;
        totalContribution += json['bonusData']['baseBufferContribution'];
        const levels = json['levelsData']['levelConfigurations'];
        for (let i = 0; i < levels.length; i++) {
            totalContribution += levels[i]['hiddenContribution'];
            totalContribution += levels[i]['visibleContribution'];
        }
        Utils.getJQueryById("#spnContributionValue").text(totalContribution.toFixed(4).replace(/\.?0+$/, ""));
        if (totalContribution > 10) {
            document.getElementById("spnContributionTooHigh").style.display = null;
            document.getElementById("spnContributionWarning").style.display = "none";
            document.getElementById("btnConfirm").style.display = "none";
            this.openDialog();
        }
        else if (totalContribution >= 2) {
            document.getElementById("spnContributionTooHigh").style.display = "none";
            document.getElementById("spnContributionWarning").style.display = null;
            document.getElementById("btnConfirm").style.display = null;
            this.openDialog();
        }
        else {
            this.configurationForm.submit();
        }
    }

    private setImportFileButtonDisabledProp(): void {
        this.importButton.disabled = this.fileInput.files.length == 0;
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/AddBonusPage.ts
 **/